var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat308(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_308"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_308",
    "data-name": 308,
    className: "cls-2",
    d: "M20.86,40c-4.72,10.34-8.55,22.26-7.29,33.76,1.39,12.57,12,25,25.49,24.53,19.83-.64,29-23.64,32.84-39.89,3.34-14,8.93-49.65-9.13-56C49.25-2.34,29.25,21.6,20.86,40Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat308);
export default __webpack_public_path__ + "static/media/cat_308.08169e12a79f1b9e2652943c11dde756.svg";
export { ForwardRef as ReactComponent };